export const checkAccessByRegions = (
  currentRegionIds: string[],
  requiredRegionIds: string[],
): boolean => {
  const requiredSet = new Set(requiredRegionIds);

  return currentRegionIds.some((regionId) => requiredSet.has(regionId));
};
